import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { pushModal } from 'loot-core/client/actions';

import { useAuth } from '../hooks/useAuth';
import { useNavigate } from '../hooks/useNavigate';

export function PostBudgetCreation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { billingStatus } = useAuth();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const isPostBudgetCreation = searchParams.get('post-budget-creation');
    if (isPostBudgetCreation !== '1') {
      return;
    }

    if (!billingStatus.isActive) {
      dispatch(
        pushModal('confirm-generic', {
          title: 'You are on the free tier',
          text: 'Upgrade your account to enjoy automatic transaction import from connected accounts, and enable data sync across all your devices.',
          cancelBtnText: 'Later',
          confirmBtnText: 'Upgrade now',
          onConfirm: () => {
            navigate('/billing');
          },
        }),
      );
    }
  }, []);

  return <></>;
}
